import React from 'react';
import {
  Enterprise,
  EntityWithDecisionsToShow,
} from '../../entity/entity.types';
import { EnterpriseList } from '../../entity/entity-lists/EnterpriseList';
import { EntityModalLoader } from '../../components/entity-modal-placeholder/EntityModalLoader';
import { fetchEntrepriseOpponents } from '../../enterprise/enterprise.api';
import {
  ModalScrollableHeader,
  ModalScrollableContent,
  ModalScrollableContainer,
} from '../../components/modal';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { EntityDecisionListModalWithGoBack } from './EntityDecisionListModalWithGoBack';

type Props = {
  wording: string;
  siren: string;
  source: string;
  raisonSociale: string;
  onRequestClose: () => void;
  isOpen: boolean;
};

type State = {
  allEnterprises: Array<Enterprise>;
  isLoading: boolean;
  entityWithDecisionsToShowInfos: EntityWithDecisionsToShow | undefined | null;
};

export class AllEnterprisesModal extends React.Component<Props, State> {
  static defaultProps = {
    onRequestClose: () => {},
    isOpen: false,
  };

  state: State = {
    allEnterprises: [],
    isLoading: true,
    entityWithDecisionsToShowInfos: null,
  };

  async componentDidMount() {
    const { oppositeEnterprises: allEnterprises } = (
      await fetchEntrepriseOpponents(this.props.siren, true)
    ).data;
    this.setState({ allEnterprises, isLoading: false });
  }

  handleClickDecision = (enterprise: Enterprise) => {
    this.setState({
      entityWithDecisionsToShowInfos: {
        name: enterprise.name,
        params: {
          oppositeSiren: enterprise.siren,
          siren: this.props.siren,
        },
      },
    });
    doctrineAnalytics('Entity SeeEntityDecisions', {
      source: `${this.props.source}_modal`,
    });
  };

  handleGoBack = () => {
    this.setState({ entityWithDecisionsToShowInfos: null });
  };

  render() {
    const {
      source,
      onRequestClose,
      raisonSociale,
      wording,
      isOpen,
    } = this.props;
    const {
      isLoading,
      allEnterprises,
      entityWithDecisionsToShowInfos,
    } = this.state;
    return (
      <ModalScrollableContainer isOpen={isOpen} onRequestClose={onRequestClose}>
        {entityWithDecisionsToShowInfos ? (
          <EntityDecisionListModalWithGoBack
            entityWithDecisionsToShowInfos={entityWithDecisionsToShowInfos}
            wording={wording}
            closeModal={onRequestClose}
            handleGoBack={this.handleGoBack}
            source={source}
          />
        ) : (
          <>
            <ModalScrollableHeader
              title={`Entreprises opposées à ${raisonSociale}`}
              onClose={onRequestClose}
            />
            <ModalScrollableContent>
              <EntityModalLoader isLoading={isLoading}>
                <EnterpriseList
                  enterprises={allEnterprises}
                  source={`${source}_modal_list`}
                  wording={wording}
                  handleClickDecision={this.handleClickDecision}
                  fromModal
                />
              </EntityModalLoader>
            </ModalScrollableContent>
          </>
        )}
      </ModalScrollableContainer>
    );
  }
}
